export const KEY = '0123456789abcdef0123456789abcdef';
export const IV = 'abcdef9876543210abcdef9876543210';



// WEBPACK FOOTER //
// ./src/config/Commons.js